(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const initProduct = (section) => {
    if (!section || section.dataset.productReady === 'true') return;
    section.dataset.productReady = 'true';

    const galleryPanels = [...section.querySelectorAll('[data-media-panel]')];
    const galleryTriggers = [...section.querySelectorAll('[data-media-trigger]')];
    const caption = section.querySelector('[data-media-caption-target]');
    const variantInput = section.querySelector('[data-variant-id]');
    const optionButtons = [...section.querySelectorAll('[data-option-button]')];
    const variantsNode = section.querySelector('[data-product-variants]');
    const priceNodes = section.querySelectorAll('[data-product-price], [data-sticky-price]');
    const compareNode = section.querySelector('[data-product-compare-price]');
    const availabilityNode = section.querySelector('[data-availability]');
    const addButtons = section.querySelectorAll('[data-add-to-cart], [data-sticky-submit]');
    const addTextNodes = section.querySelectorAll('[data-add-to-cart-text], [data-sticky-text]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const currency = section.dataset.currency || 'USD';
    let variants = [];

    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) { variants = []; }

    const activateMedia = (id) => {
      if (!id) return;
      let activePanel = null;
      galleryPanels.forEach((panel) => {
        const active = String(panel.dataset.mediaId) === String(id);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) activePanel = panel;
      });
      galleryTriggers.forEach((trigger) => {
        const active = String(trigger.dataset.mediaTrigger) === String(id);
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (activePanel && caption) caption.textContent = activePanel.dataset.mediaCaption || '';
    };

    galleryTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => activateMedia(trigger.dataset.mediaTrigger));
    });

    const selectedOptions = () => {
      const groups = new Map();
      optionButtons.forEach((button) => {
        if (button.classList.contains('is-selected')) {
          groups.set(Number(button.dataset.optionIndex), button.dataset.optionValue);
        }
      });
      return [...groups.entries()].sort((a, b) => a[0] - b[0]).map((entry) => entry[1]);
    };

    const updateVariant = () => {
      if (!variants.length || !variantInput) return;
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        addButtons.forEach((button) => { button.disabled = true; });
        addTextNodes.forEach((node) => { node.textContent = 'Unavailable'; });
        if (availabilityNode) availabilityNode.textContent = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;
      priceNodes.forEach((node) => { node.textContent = money(variant.price, currency); });
      if (compareNode) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareNode.hidden = !showCompare;
        compareNode.textContent = showCompare ? money(variant.compare_at_price, currency) : '';
      }
      addButtons.forEach((button) => { button.disabled = !variant.available; });
      addTextNodes.forEach((node) => { node.textContent = variant.available ? 'Add to cart' : 'Sold out'; });
      if (availabilityNode) availabilityNode.textContent = variant.available ? 'In stock' : 'Sold out';

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) activateMedia(mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-option-group]');
        group?.querySelectorAll('[data-option-button]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        updateVariant();
      });
    });

    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    quantityInput?.addEventListener('change', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1));
    });
  };

  const initAll = (root = document) => root.querySelectorAll('[data-product-section]').forEach(initProduct);
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
